// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function Tabs$Tabs(props) {
  let __className = props.className;
  let onChange = props.onChange;
  let value = props.value;
  let tabs = props.tabs;
  let className = __className !== undefined ? __className : "";
  let tab = tabs[0];
  let firstId = tab !== undefined ? tab.id : "";
  let match = React.useState(() => firstId);
  let setInternal = match[1];
  let selected = value !== undefined ? value : match[0];
  let listStyles = Emotion.Css.css({
    display: "flex",
    gap: "0",
    borderBottom: `1px solid ` + Emotion.Utils.Color.border,
    overflowX: "auto"
  });
  let tabStyles = active => Emotion.Css.css({
    appearance: "none",
    background: "transparent",
    border: "none",
    borderBottom: active ? `2px solid ` + Emotion.Utils.Color.primary : "2px solid transparent",
    color: active ? Emotion.Utils.Color.textPrimary : Emotion.Utils.Color.textSecondary,
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: "0.75rem",
    fontWeight: active ? "600" : "400",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    padding: "0.85rem 1.1rem",
    marginBottom: "-1px",
    whiteSpace: "nowrap",
    ":focus-visible": {
      outline: "none",
      boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
    }
  });
  let panel = tabs.find(tab => tab.id === selected);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: tabs.map(tab => {
          let active = tab.id === selected;
          return JsxRuntime.jsx("button", {
            children: tab.label,
            "aria-selected": active,
            "aria-controls": "panel-" + tab.id,
            className: tabStyles(active),
            id: "tab-" + tab.id,
            role: "tab",
            type: "button",
            onClick: param => {
              let id = tab.id;
              setInternal(param => id);
              if (onChange !== undefined) {
                return onChange(id);
              }
            }
          }, tab.id);
        }),
        className: listStyles,
        role: "tablist"
      }),
      panel !== undefined ? JsxRuntime.jsx("div", {
          children: panel.content,
          "aria-labelledby": "tab-" + panel.id,
          className: Emotion.Css.css({
            paddingTop: "2rem"
          }),
          id: "panel-" + panel.id,
          role: "tabpanel"
        }) : null
    ],
    className: className
  });
}

let Tabs = {
  make: Tabs$Tabs
};

export {
  Tabs,
}
/* react Not a pure module */
